import { TextRegular } from 'UiKit/typography';

import ColumnPresence from 'View/report-attendance-host-detail/component/column-presence';
import ColumnLivestream from 'View/report-attendance-host-detail/component/column-livestream';

import styles from './styles.module.css';

export const tableList = ({ t }) => {
  return [
    {
      name: t('tableColumn.dateShift'),
      width: 120,
      key: 'shiftDate',
      component: ({ value }) => <TextRegular className={styles['column__text']}>{value}</TextRegular>,
    },
    {
      name: t('tableColumn.clockIn'),
      width: 420,
      key: 'clockIn',
      component: ({ value }) => <ColumnPresence value={value} />,
    },
    {
      name: t('tableColumn.clockOut'),
      width: 420,
      key: 'clockOut',
      component: ({ value }) => <ColumnPresence value={value} type={'clockOut'} />,
    },
    {
      name: t('tableColumn.livestream'),
      width: 200,
      key: `livestream`,
      component: ({ values }) => <ColumnLivestream values={values} />,
    },
  ];
};
